import gql from 'graphql-tag';

const DELETE_ITEM_MUTATION = gql`
  mutation deleteCategoryItem($_id: ID!) {
    deleteCategoryItem(_id: $_id)
  }
`;

export default DELETE_ITEM_MUTATION;
